function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#26D9B1",
  cx: "10",
  cy: "10",
  r: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 5.5h3a1 1 0 110 2h-3a1 1 0 110-2zM5.5 8.5h3a1 1 0 010 2h-3a1 1 0 110-2zM11.5 8.5h3a1 1 0 010 2h-3a1 1 0 010-2zM7 11.5h3a1 1 0 010 2H7a1 1 0 010-2zM13 11.5h3a1 1 0 010 2h-3a1 1 0 010-2zM10.5 5.5h3a1 1 0 010 2h-3a1 1 0 110-2z",
  fill: "#FFF"
}))));